module.exports = __webpack_public_path__ + "img/outer-3.52c76c36.png";